import { Component, inject, OnInit } from '@angular/core';
import { Backend } from 'src/app/backend-interface/backend';
import { HasRolesDirective } from 'keycloak-angular';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { TranslationService } from 'src/app/service/translation.service';
import { CommonModule } from '@angular/common';
import Keycloak from 'keycloak-js';
import { GlobalService } from 'src/app/service/global.service';

/**
 * Component which is shared by mains components
 */
@Component({
  selector: 'app-components-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss'],
  providers: [TranslationService, GlobalService],
  imports: [CommonModule, RouterModule, HasRolesDirective, TranslateModule],
  standalone: true
})
export class NavbarComponent implements OnInit {
  logoEquipe = '../../assets/images/home/logoEquipeDIP.svg';
  logoWorldline = '../../assets/images/home/logoWorldline.svg';
  chemimagecard = '../assets/images/home/card/';
  searchpath = '../assets/icons/NavBar/search.svg';
  navigation = [
    { label: 'Compromise Reports', route: '/compromise-reports', role: 'bo-dip-policy-violations-viewer' },
    { label: 'Attestations', route: '/attestations', role: 'bo-dip-attestations-viewer' },
    { label: 'Security Policies', route: '/security-policies', role: 'bo-dip-security-policies-viewer' },
    { label: 'Settings', route: '/settings', role: 'bo-dip-wl-admin' }
  ];
  public readonly keycloak = inject(Keycloak)
  public readonly globalService = inject(GlobalService);
  
  welcome: string = '';

  private readonly translationService = inject(TranslationService);
  
  ngOnInit(): void {
   
    this.keycloak.loadUserProfile().then(profile => {
      this.welcome = Backend.FORMAT.welcomeUser(profile.firstName + ' ' + profile.lastName);
    });
  }
}
